/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '.';
import type { Result, Headers } from '../type';

type Options = {
    headers?: Headers;
    result?: Result;
};

export default function remove<T>(url: string, options?: Options) {
    return request<T>(url, {
        headers: options?.headers,
        method: 'DELETE',
        result: options?.result
    });
}
